module.exports = __webpack_public_path__ + "media/video-inside.0437026d.mp4";